<template>
  <transition name="modal" v-if="customizedProdData && Object.keys(customizedProdData).length">
    <div class="modalcon">
      <div class="modal-mask" @click="$emit('close')">
        <div class="modal-wrapper">
          <div class="modal-container" id='customization-modal' @click.stop>
            <div class="closebtn d-flex justify-content-end" @click="$emit('close')">
              <img class='pointer' src='https://tss-static-images.gumlet.io/cross.png'/>
            </div>
            <div class="main-img d-flex justify-content-center">
              <div class='w-full prelative' id='img-wrapper'>
                <img
                  :data-src="customizedProdData.magnifyImg"
                  alt='customized-image'
                >
                <div v-if="printName || printNumber" class='print-content w-full d-flex align-items-center flex-column' :style="{ color: customizedProdData.textColor}">
                  <div class="print-number font-franklin-medium" :class="{'font-optima-medium': artistSlug === 'lucknow-super-giants'}">
                    {{printNumber}}
                  </div>
                  <p class="print-name text-uppercase font-alinea-sans-bold" :class="{'font-franklin-medium': artistSlug ==='chennai-super-kings', 'font-optima-medium': artistSlug === 'lucknow-super-giants'}">{{printName}}</p>
                </div>
              </div>
            </div>
            <div class="print-input-fields mt20">
              <p class='pl10'>Add name and number <span class='fbold'>(Rs. {{customizedProdData.customizationPrice}} extra)</span></p>
              <div class="numberInput prelative">
                <input class="form-control" type="text" maxlength="2" placeholder="Type your number (max. 2 digits)" v-model="printNumber" @keyup="validatePrintNumber">
                <img class="green-tick" v-if="isValidPrintNumber" data-src="https://tss-static-images.gumlet.io/checkmark.png">
              </div>
              <div class='nameInput prelative mt-2'>
                <input type="text" class="form-control" maxlength="8" placeholder="Type your name (max. 8 characters)" :value="printName" @input="changePrintName"  @keyup="validatePrintName">
                <img class="green-tick" v-if="isValidPrintText" data-src="https://tss-static-images.gumlet.io/checkmark.png">
              </div>
              <button class='btn btn-danger text-uppercase w-full mt10 fwhite' :disabled="!(printName && printNumber)" @click="confirmCustomization(printName, printNumber)">confirm</button>
              <!-- <div v-if="printName || printNumber" @click="downloadCustomization" class='d-flex justify-content-end align-items-center selectcolor pointer mt-1 download-btn'>
                <span v-if="printName || printNumber">Download & Preview</span>
                <i class="fa fa-download ml-1"></i>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import html2canvas from 'html2canvas'
  export default {
    data () {
      return {
        printName: '',
        printNumber: '',
        customizedImg: ''
      }
    },
    props: ['customizedProdData', 'confirmCustomization', 'prodPrintName', 'prodPrintNumber', 'artistSlug'],
    methods: {
      changePrintName: function (event) {
        const value = event.target.value
        this.printName = value ? value.toUpperCase() : ''
      },
      validatePrintName: function () {
        let lenRestriction = 8
        if (this.printName && this.printName.replace(/ /g, '') && this.printName.replace(/ /g, '').length > lenRestriction) {
          this.printName = this.printName.substring(0, lenRestriction + (this.printName.split(' ').length - 1))
        }
        const regex = /[^a-zA-Z]+/g
        const containSplChar = regex.test(this.printName)
        if (containSplChar) {
          const str = this.printName.replace(regex, '')
          this.printName = str
        }
      },
      validatePrintNumber: function () {
        if (!this.printNumber.match(/^[0-9]{1,2}[:.,-]?$/g)) {
          if (this.printNumber[0] && !this.printNumber[0].match(/[0-9]/g) && this.printNumber[1] && !this.printNumber[1].match(/[0-9]/g)) {
            this.printNumber = ''
          } else if (this.printNumber[1] && !this.printNumber[1].match(/[0-9]/g)) {
            this.printNumber = this.printNumber[0]
          } else {
            this.printNumber = ''
          }
        }
      },
      downloadCustomization () {
        const imgWrapperEl = document.getElementById('img-wrapper')
        const customizedWrapperEl = document.getElementById('customization-modal')
        if (imgWrapperEl && customizedWrapperEl) {
          html2canvas(imgWrapperEl, {useCORS: true}).then(canvas => {
            const link = document.createElement('a')
            link.href = canvas.toDataURL()
            link.download = 'Customised.png'
            customizedWrapperEl.appendChild(link)
            link.click()
            customizedWrapperEl.removeChild(link)
          }).catch((error) => {
            console.log('Error: ', error)
          })
        }
      }
    },
    computed: {
      isValidPrintText: function () {
        let customInputString = this.printName.replace(/ /g, '')
        const regex = /[^a-zA-Z]+/g
        return customInputString && customInputString.length && !regex.test(customInputString)
      },
      isValidPrintNumber: function () {
        return this.printNumber && this.printNumber.length && this.printNumber.match(/^[0-9]{1,2}[:.,-]?$/g)
      }
    },
    mounted () {
      // hide vertical scroll on body on mount
      const el = document.querySelector('body')
      el && el.classList.add('overflow-y-hidden')

      // Initialize print name and print number
      if (this.prodPrintName) this.printName = this.prodPrintName
      if (this.prodPrintNumber) this.printNumber = this.prodPrintNumber

      // Image background
      const imgWrapperEl = document.getElementById('img-wrapper')
      if (imgWrapperEl) {
        const resolution = [362, 478]
        const ratio = resolution[0] / resolution[1]
        let renderWidth = imgWrapperEl.clientWidth
        let renderHeight = parseInt(renderWidth / ratio)
        imgWrapperEl.style.height = renderHeight + 'px'
        imgWrapperEl.style.background = '#FFEBE7'
      }
    },
    destroyed () {
      // remove hidden vertical scroll on destroy
      const el = document.querySelector('body')
      el && el.classList.remove('overflow-y-hidden')
    }
  }
</script>
<style scoped="scoped">
  ::-webkit-input-placeholder {
    font-style: italic;
  }
  .download-btn {
    font-size: 13px;
    margin-bottom: -5px;
  }
  .modal-container .main-img {
   padding: 0px 35px;
   margin-top: 5px;
  }

  .modalcon {
    position: fixed;
    display: block;
    left: 0;
    z-index: 10000;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    overflow-x: hidden;
    overflow-y: auto;
    transition: opacity .3s ease;
  }

  .modal-mask {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;

  }
  .second-no-wrapper {
    position: relative;
  }

  .closebtn img{
    width: 14px;
  }

  .print-content {
    position: absolute;
    top: 0;
    top: 36%;
    color: black;
  }
  .print-input-fields p {
    font-size: 13px;
  }
  .print-input-fields input {
    border: 1px solid #707070;
    border-radius: 7px;
    font-size: 14px;
  }
  .print-input-fields button {
    background-color: rgb(236, 61, 37);
    border-color: rgb(255, 255, 255);
  }
  .print-content p{
    margin-bottom: 0px;
  }
  .print-name {
    font-size: 14px;
  }
  .print-number {
    font-size: 3.2rem;
    text-transform: capitalize;
    line-height: 1.1;
    font-weight: bold;
  }
  .green-tick {
    width: 30px;
    position: absolute;
    right: 4px;
    top: 4px;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    margin: 0px auto;
    transition: all 0.3s ease;
    width: 340px;
    padding: 5px 15px 15px 15px;
    border-radius: 10px;
    background-color: white;
  }

  .modal-header {
    padding: 5px;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-footer {
    padding: 15px 5px 5px 5px;
  }

  .modal-body {
    margin: 0px 0 0px 0;
    padding: 0px;
    position: relative;
    height: 100%;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .imageOverNumber {
    position: absolute;
    top: 10px;
    right: -15px;
    width: 35px;
  }

  @media screen and (max-width: 768px) {
    .zoomimage {
      width: 320px;
      margin-left: -160px;
    }

    .printName {
      top: 80px;
      font-size: 16px;
    }

    .printNumber {
      top: 85px;
      font-size: 75px;
    }

    .number1 {
      margin: 0px 0px 0px -35px;
    }

    .number2 {
      margin: 0px 0px 0px 38px;
    }

    .imageOverNumber {
      bottom: 37px;
      right: -10px;
      width: 30px;
    }
    .print-number {
      font-size: 2.8rem;
    }
  }
  @media screen and (max-width: 420px){
    .modal-container{
      width: 92%;
    }
  }
  @media screen and (max-width: 360px){
    .modal-container {
      width: 88%;
    }
    .print-input-fields{
      margin-top: 10px
    }
    .print-input-fields p {
      font-size: 12px;
    }
    .modal-container .main-img {
      padding: 0px 40px
    }
    .form-control {
      line-height: 27px;
    }
    .green-tick {
      width: 28px;
      top: 5px;
    }
    .print-input-fields button {
      line-height: 27px;
    }
  }
   @media screen and (max-width: 320px){
    .modal-container {
      width: 88%;
       padding: 5px 15px 10px 15px;
    }
    .form-control {
      line-height: 25px;
    }
    .print-input-fields button {
      line-height: 25px;
    }
    .green-tick {
      width: 26px;
    }
    .main-img {
      margin-top: 0px;
    }
    .print-input-fields p {
      font-size: 10px;
    }
    .print-name {
      font-size: 10px;
    }
    .print-number {
      font-size: 2.2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// customizedProdModal.vue?491f8380